module.exports = __webpack_public_path__ + "static/media/book-dead.8495079e.svg";